import { Controller } from "@hotwired/stimulus"

// Per-veld auto-save naar het single-field endpoint (geeft 204 of 422-JSON, geen
// HTML). We sturen via fetch zodat er geen page-reload/Turbo-navigatie nodig is en
// we de uitkomst kunnen tonen: groene flash bij succes, rode flash + tooltip bij
// een validatiefout.
//
// Form:   data-controller="inline-save" + data-action="submit->inline-save#submitForm"
// Tekst/getal:    data-action="input->inline-save#schedule"   (gedebounced)
// Select/checkbox: data-action="change->inline-save#submit"   (direct)
export default class extends Controller {
  static values = { delay: { type: Number, default: 600 } }

  schedule() {
    clearTimeout(this._timeout)
    this._timeout = setTimeout(() => this.save(), this.delayValue)
  }

  submit() {
    clearTimeout(this._timeout)
    this.save()
  }

  submitForm(event) {
    event.preventDefault()
    this.submit()
  }

  disconnect() {
    clearTimeout(this._timeout)
  }

  async save() {
    const form = this.element
    const token = document.querySelector('meta[name="csrf-token"]')?.content
    try {
      const response = await fetch(form.action, {
        method: "PATCH",
        headers: { "X-CSRF-Token": token, Accept: "application/json" },
        body: new FormData(form)
      })
      if (response.ok) {
        this.flash(true)
      } else {
        let message = ""
        try {
          const data = await response.json()
          message = (data.errors || []).join(", ")
        } catch (_e) { /* geen JSON-body */ }
        this.flash(false, message)
      }
    } catch (_e) {
      this.flash(false)
    }
  }

  flash(ok, message) {
    const el = this.element
    el.classList.remove("inline-save-ok", "inline-save-err")
    void el.offsetWidth // herstart de CSS-animatie
    el.classList.add(ok ? "inline-save-ok" : "inline-save-err")
    if (message) { el.title = message } else { el.removeAttribute("title") }
    setTimeout(() => el.classList.remove("inline-save-ok", "inline-save-err"), 1200)
  }
}
